export default __webpack_public_path__ + "static/media/8_aanya_singh.aa9ee008.jpg";